import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import _ from 'lodash';

class RevisionShow extends Component{
	render(){
		const {revision} =this.props;
		//let gc = _.find(goals.permissions, (o) => {return o==='Create'});
		return (
			!_.isEmpty(revision.commission.spvpu) && !_.isEmpty(revision.commission.answers) ?
			<div className="field">
				<button className="button is-small is-inm-purple" onClick={() => this.props.change('revision.surveyShow',!revision.surveyShow)}>
					<span>Revisar encuesta</span>&nbsp;
					{/*<span className="icon is-small">
						<i className="fa fa-chevron-down fa-fw"/>
					</span>*/}
				</button>
			</div>:''
		)
	}
}

export default SecureLayout(RevisionShow);


// WEBPACK FOOTER //
// ./src/elements/revision/widget/revision_show.jsx